<template>
  <b-card>
    <div class="d-flex justify-content-between w-100">
      <h3>تفاصيل الخبر</h3>
      <div class="d-flex align-items-center">
        <b-button
          v-can="{ slug: $route.meta.slug, action: 'U' }"
          variant="flat-primary"
          class="btn-icon rounded-circle"
          @click="activSide = true"
        >
          <feather-icon size="15" icon="EditIcon" />
        </b-button>
        <loader-btn
          v-can="{ slug: $route.meta.slug, action: 'D' }"
          :loading="loading"
          @click="onDeleteClicked"
          icon="Trash2Icon"
          class="mx-50"
          variant="flat-danger"
          iconOnly
        />
        <div>
          <b-button
            variant="outline-primary"
            class="p-50"
            @click="$router.go(-1)"
            ><feather-icon icon="ArrowLeftIcon" size="24"
          /></b-button>
        </div>
      </div>
    </div>
    <hr />
    <div v-if="loadingDetails">
      <div class="d-flex justify-content-between">
        <b-skeleton width="300px" height="180px"> </b-skeleton>
        <div>
          <b-skeleton v-for="n in 7" :key="n" width="270px"></b-skeleton>
        </div>
        <div>
          <b-skeleton width="100px"></b-skeleton>
          <b-skeleton v-for="n in 6" :key="n" width="300px"></b-skeleton>
        </div>
      </div>
    </div>
    <b-row v-else v-can="{ slug: $route.meta.slug, action: 'S' }">
      <b-col cols="12" class="">
        <b-row>
          <b-col cols="6">
            <img
              :src="detailsNews.image"
              alt="events"
              style="object-fit: cover; width: 100%; height: auto"
            />
          </b-col>
          <b-col cols="6">
            <b-row>
              <b-col cols="12" class="">
                <div>
                  <b-media no-body class="mb-1 b-flex align-items-center">
                    <b-media-aside class="mr-1">
                      <b-avatar rounded variant="light-primary" size="34">
                        <feather-icon icon="CalendarIcon" size="18" />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body>
                      <h6 class="mb-0">
                        {{ detailsNews.accomplished_at_date }}
                      </h6>
                    </b-media-body>
                  </b-media>
                </div>

                <b-media no-body class="mb-1 b-flex align-items-center">
                  <b-media-aside class="mr-1">
                    <b-avatar rounded variant="light-primary" size="34">
                      <feather-icon icon="MapPinIcon" size="18" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h6 class="mb-0">
                      {{
                        detailsNews.governorate
                          ? detailsNews.governorate.name_ar
                          : ""
                      }}
                    </h6>
                  </b-media-body>
                </b-media>
              </b-col>
              <b-col cols="12" class="">
                <b-card-text>
                  <h3 class="mb-1">التفاصيل</h3>
                  <p class="mx-1 text-justify">
                    {{ detailsNews.description_ar }}
                  </p>
                </b-card-text>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="12" class="mt-4">
        <h3>معرض الصور</h3>
        <swiper
          class="swiper-responsive-breakpoints"
          :options="swiperOptions"
          v-if="detailsNews.newSlides && detailsNews.newSlides.length > 0"
        >
          <swiper-slide
            v-for="(data, index) in detailsNews.newSlides"
            :key="index"
          >
            <b-img :src="data.image" fluid style="width: 100%; height: 175px" />
          </swiper-slide>
          <div
            slot="button-next"
            class="swiper-button-next"
            style="color: #fff"
          />
          <div
            slot="button-prev"
            class="swiper-button-prev"
            style="color: #fff"
          />
          <div slot="pagination" class="swiper-pagination" />
        </swiper>
        <alert
          v-else
          massage="عذراً لا يوجد نتائج لعرضها"
          class="w-100"
        ></alert>
      </b-col>

      <b-col cols="12" class="mt-4">
        <h3>فيديو الخبر</h3>
        <div
          v-if="detailsNews.video"
          class="video_mine mt-2 w-100 d-flex justify-content-center"
        >
          <video class="w-50" controls>
            <source :src="detailsNews.video" type="video/mp4" />
            <source :src="detailsNews.video" type="video/ogg" />
          </video>
        </div>
        <alert
          v-else
          massage="عذراً لا يوجد نتائج لعرضها"
          class="w-100"
        ></alert>
      </b-col>
    </b-row>
    <modal-news
      v-model="activSide"
      :newsFormSchema="newsFormSchema"
      type="edit"
    ></modal-news>
    <!-- <form-modal v-model="activSide" :formSchema="newsFormSchema" /> -->
  </b-card>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BImg,
  BMedia,
  BButton,
  BMediaAside,
  BAvatar,
  BMediaBody,
  BCardText,
  BModal,
  BSkeleton,
} from "bootstrap-vue";
import ModalNews from "../../components/ModalNews.vue";
import FormModal from "@/components/FormModal.vue";
import { mapGetters } from "vuex";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import Alert from "@/components/Alert.vue";
import LoaderBtn from "@/components/loader-btn.vue";

export default {
  props: ["id"],
  components: {
    BCard,
    BRow,
    BCol,
    BImg,
    Swiper,
    SwiperSlide,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    BButton,
    BCardText,
    ModalNews,
    Alert,
    BModal,
    BSkeleton,
    FormModal,
    LoaderBtn,
  },
  data: () => {
    return {
      activeDelete: false,
      activSide: false,
      newsFormSchema: {
        title_ar: {
          component: "FormInput",
          key: "title_ar",
          attrs: {
            label: "العنوان",
            rules: "required",
          },
        },
        accomplished_at_date: {
          component: "FormMask",
          key: "accomplished_at_date",
          attrs: {
            label: "التاريخ",
            options: "date",
            rules: "required",
            placeholder: "YY-MM-DD",
          },
        },

        governorate_id: {
          component: "FormSelect",
          key: "governorate_id",
          attrs: {
            id: "gov_edit_news",
            label: "المحافظة",
            ep: "v2/selects/governorates",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
            rules: "required",
          },
        },

        description_ar: {
          component: "FormTextarea",
          key: "description_ar",
          attrs: {
            label: "الوصف",
            rules: "required",
          },
        },
      },
      swiperOptions: {
        slidesPerView: 5,
        spaceBetween: 50,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  methods: {
    onDeleteClicked() {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف الخبر ؟", {
          title: "تأكيد حذف الخبر",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            await this.$store
              .dispatch("manageInterfaceNgo/NewsManagement/deleteNews", {
                id: this.id,
              })
              .then(() => {
                this.$router.push({ name: "news-management" });
              });
          }
        });
    },
  },
  computed: {
    ...mapGetters("manageInterfaceNgo/NewsManagement", [
      "detailsNews",
      "loadingDetails",
      "loading",
    ]),
  },
  created() {
    this.$store.dispatch("manageInterfaceNgo/NewsManagement/getDetailsNews", {
      id: this.id,
    });
  },
};
</script>
